const formatPrice = price => {
  return price / 100;
};

export { formatPrice };
